import { ErrorHandler, Injectable, isDevMode, inject } from '@angular/core';
import { ClientLoggerService } from './client-logger.service';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
  private readonly logger = inject(ClientLoggerService);
  private devModeMessageLogged = false;

  handleError(error: unknown): void {
    this.logger.fatal('Application Error', error, {
      source: 'global-error-handler',
    });

    if (isDevMode() && !this.devModeMessageLogged) {
      this.devModeMessageLogged = true;
      this.logger.warn('Angular dev mode enabled - full stack traces available');
    }
  }
}
